import React, { useEffect, useState, useRef } from 'react';
import MetaTags from 'react-meta-tags';
import { Helmet } from "react-helmet";
import { Navbar, DB_Header, Contenido, Votar, ComentariosR, Blogs_relacionados } from '../container';
import FooterPrime from '../container/Footer/Footer';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//import BotonFlotante from '../components/btnFloat/btnflotante'

const DetallesBlog = () => {
  const { friendly } = useParams();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const idiomaliga = queryParams.get("lang");
  const [t, i18n] = useTranslation("global");
  const [apiUrl, setApiUrl] = useState('');

  // Ref para controlar la primera ejecución
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (idiomaliga) {
      console.log("Idioma: " + idiomaliga);
      setApiUrl(`/blogs/by-friendly/${friendly}?lang=${idiomaliga}`);
    } else {
      setApiUrl(`/blogs/by-friendly-lang/${friendly}`);
    }
  }, [idiomaliga]);

  const { data, isLoading, error } = useAxios(apiUrl);
  const { titulo, categorias, fecha, lenguaje, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      console.log("La primera vez");
    } else {
      if (!idiomaliga) {
        setApiUrl(`/blogs/by-friendly/${friendly}?lang=${i18n.language}`);
        console.log("Cambio la liga");
      }
    }
  }, [i18n.language]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      console.log("La primera vez del tag");
    } else {
      if (!idiomaliga) {
        if (tag && tag != 'undefined') {
          navigate(`/blog/${tag}`);
          console.log("Cambio la liga del navegador");
        }
      }
    }
  }, [tag]);

  useEffect(() => {
    if (data && lenguaje && lenguaje !== i18n.language) {
      i18n.changeLanguage(lenguaje);
      console.log(`Idioma del sitio cambiado a ${lenguaje}`);

      const button = document.getElementById("btn_cm_idm");
      if (button) {
        button.click();
        console.log("Botón 'btn_cm_idm' clickeado");
      }
    }
  }, [data, lenguaje, i18n]);

  const resumensplit = (txtresumen) => {
    if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
      const partes = txtresumen.split("||");
      if (partes.length > 1 && partes[0].trim() !== "") {
        return partes[0].trim();
      }
    }
    return txtresumen;
  };

  return (
    <>
      {
        isLoading
          ? (<h1>Loading...</h1>)
          : (
            <div className='App_DB'>
              <MetaTags>
                <title>{titulo}</title>
                {/* 
                <meta name="description" content={resumensplit(resumen)} />
                <meta property="og:title" content={titulo} />
                <meta property="og:description" content={resumensplit(resumen)} />
                <meta property="og:url" content={"https://www.ricardosalinas.com/blog/" + tag} />
                <meta property="og:image" content={urlImagen} />
                <meta name="twitter:title" content={titulo} />
                <meta name="twitter:image" content={urlImagen} />
                <meta name="twitter:url" content={"https://www.ricardosalinas.com/blog/" + tag} />
                */}
              </MetaTags>
              <Navbar />
              <DB_Header titulo={titulo} categorias={categorias} urlImagen={urlImagen} fecha={fecha} resumen={resumen} />
              <Contenido contenidoHtml={contenidoHtml} titulo={titulo} />
              <Votar friendlyTag={friendly} />
              <ComentariosR comentarios={comentarios} friendlyTag={tag} guid={guid} titulo={titulo} />
              <Blogs_relacionados blogsRelacionados={blogsRelacionados} categorias={categorias} />
              {/* <BotonFlotante/>*/}
              <FooterPrime />
            </div>
          )
      }
    </>
  );
}

export default DetallesBlog;